import Vue from 'vue';
import Axios from 'axios';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  isBusy: false,
  data: [],
  error: null // status
}

const mutations = {
  SET_GEN_COUNTRIES_BUSY: (state, payload) => {
    state.isBusy = payload;
  },
  SET_GEN_COUNTRIES_SUCCESS: (state, payload) => {
    state.data = payload.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    });
    state.error = null;
  },
  SET_GEN_COUNTRIES_FAIL: (state, payload) => {
    state.data = null;
    state.error = payload;
  }
}

const actions = {
  lookupCountries: ({ commit, state, rootState }, { filters } = {}) => {

    return new Promise((resolve, reject) => {

      if(state.isBusy) return reject('busy')

      commit('SET_GEN_COUNTRIES_BUSY', true);

      const { accessToken } = rootState.user.user.data;

      const config = {
        headers: { Authorization: `Token token=${accessToken}` },
      };

      if(filters) config.params = filters;

      Axios.get(`${API_HOST}/lookups/countries`, config)
        .then(({ data: { data } }) => {
          commit('SET_GEN_COUNTRIES_SUCCESS', data)
          resolve(data)
        })
        .catch(({ response }) => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error') || ''
          });
          commit('SET_GEN_COUNTRIES_FAIL', response.status);
          reject(response);
        })
        .finally(() => commit('SET_GEN_COUNTRIES_BUSY', false));
    })
  }
};

export default {
  state,
  mutations,
  actions
};